import React, { useState } from 'react'
import {
  Row, Col, Input, Modal,
} from 'antd'

import __ from '../../languages/parser'

const SIZE = 'default'

const checkIsNumber = (value) => {
  const reg = /^-?[0-9]*(\.[0-9]*)?$/
  return ((!Number.isNaN(value) && reg.test(value)) || value === '' || value === '-')
}

const BoxModal = ({
  show,
  cancel,
  addBox,
}) => {
  const [width, setWidth] = useState(null)
  const [height, setHeight] = useState(null)
  const [boxName, setBoxName] = useState(null)
  const [boxType] = useState('wall')

  return (
    <Modal
      title={__('Create an item')}
      visible={show}
      onOk={() => addBox({
        width, height, boxName, boxType,
      })}
      onCancel={cancel}
      zIndex={10000}
      cancelText={__('Cancel')}
    >
      <Row style={{ marginBottom: '10px' }}>
        <Col span={6}>{__('Width')}</Col>
        <Col>
          <Input
            placeholder={`${__('Width')} (cm)`}
            disabled={boxType === 'vArrow'}
            value={width || null}
            size={SIZE}
            onChange={(e) => {
              if (checkIsNumber(e.target.value)) { setWidth(parseInt(e.target.value, 10)) }
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '10px' }}>
        <Col span={6}>{__('Height')}</Col>
        <Col>
          <Input
            placeholder={`${__('Height')} (cm)`}
            disabled={boxType === 'hArrow'}
            value={height || null}
            size={SIZE}
            onChange={(e) => {
              if (checkIsNumber(e.target.value)) { setHeight(parseInt(e.target.value, 10)) }
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: '10px' }}>
        <Col span={6}>{__('Name')}</Col>
        <Col><Input placeholder="Nom" size={SIZE} onChange={(e) => setBoxName(e.target.value)} /></Col>
      </Row>
    </Modal>
  )
}

export default BoxModal
